import { Locale } from '@/common/model';
import { Button } from '@/components/ui/button';
import { cn } from '@/utils';
import { ClassValue } from 'clsx';

interface Props {
  className?: ClassValue;
  locale: Locale;
  onClick: () => void;
}

export function LocaleButton({ className, locale, onClick }: Props) {
  const text = locale === 'en' ? '한국어' : 'English';
  return (
    <Button className={cn(className)} onClick={onClick}>
      {text}
    </Button>
  );
}
